import { COLORS } from '@/styles/colorTheme';
import { Container, TextContainer, Img } from './Score3Styles';
import up from '@/assets/redUpNarrowArrow.svg';
import down from '@/assets/blueDownNarrowArrow.svg';
import zero from '@/assets/zero.svg';
import { cn } from '@/lib/utils';

const Score3 = ({ change }) => {
  if (change === undefined) return;

  const data_ = change;

  let background = COLORS.Background100;
  let color = COLORS.Text400;

  if (data_ > 0) {
    background = COLORS.Red100;
    color = COLORS.Red200;
  }

  if (data_ < 0) {
    background = COLORS.Blue100;
    color = COLORS.Blue200;
  }

  return (
    <Container background={background}>
      {data_ < 0 ? <Img src={down} alt="down" /> : null}
      {data_ > 0 ? <Img src={up} alt="up" /> : null}
      {data_ === 0 ? <Img src={zero} alt="zero" /> : null}

      <TextContainer>
        <div
          className={cn(
            `text-sm`,
            data_ === 0
              ? 'text-text-400'
              : data_ > 0
              ? 'text-legacy-red-200'
              : 'text-legacy-blue-200',
          )}
        >
          {Math.abs(change).toFixed(2)}
        </div>
        <div
          className={cn(
            `text-sm`,
            data_ === 0
              ? 'text-text-400'
              : data_ > 0
              ? 'text-legacy-red-200'
              : 'text-legacy-blue-200',
          )}
        >
          %
        </div>
      </TextContainer>
    </Container>
  );
};

export default Score3;
